import { Component, Input, OnChanges } from '@angular/core';

import { HtmlService } from '../../../../../../services/html.service';

@Component({
    selector: 'picture-resource',
    template: require('./picture-resource.component.html'),
})
export class PictureResourceComponent implements OnChanges {
    @Input() id: number;
    srcUrl: string;

    constructor(private htmlService: HtmlService) { }

    ngOnChanges() {
        this.srcUrl = this.htmlService.getResourceUrl(this.id);
    }
}



// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body-panel/resource/picture-resource/picture-resource.component.ts